/* code below derived from  https://github.com/ariutta/svg-pan-zoom/blob/e62c698df0654eb2afa39f28b792f1bc9fab44ad/demo/mobile.html
 and is under this BSD license https://github.com/ariutta/svg-pan-zoom/blob/master/LICENSE */

import svgPanZoom from 'svg-pan-zoom'
import Hammer from 'hammerjs'

export function panzoom(node) {
    var eventsHandler: SvgPanZoom.CustomEventHandler;

    // Listen only for pointer and touch events
    var hammer = new Hammer(node, {
        //  inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
    })

    // Enable pinch
    hammer.get('pinch').set({ enable: true })
    hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });


    eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel', 'mousedown', 'mouseup', 'mousemove'],
        init: function (options: SvgPanZoom.CustomEventOptions) {
            var instance = options.instance
                , initialScale = 1
                , pannedX = 0
                , pannedY = 0

            var pinchCenter = null;
            
            function startPan(ev) {
                pannedX = ev.deltaX;
                pannedY = ev.deltaY;
            }

            function pan(ev) {
                var sizes = instance.getSizes()
                var gutterWidth = 100 * sizes.realZoom;
                var gutterHeight = 100 * sizes.realZoom;
    
                var leftLimit = -(((sizes.viewBox as any).x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
                var rightLimit = sizes.width - gutterWidth - ((sizes.viewBox as any).x * sizes.realZoom)
                var topLimit =  -(((sizes.viewBox as any).y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
                var bottomLimit = sizes.height - gutterHeight - ((sizes.viewBox as any).y * sizes.realZoom)
    
                let p = instance.getPan();
                let newx = ev.deltaX - pannedX;
                let newy = ev.deltaY - pannedY;

                let totalx = p.x + newx;
                let totaly = p.y + newy;

                totalx = Math.max(leftLimit, Math.min(rightLimit, totalx));
                totaly = Math.max(topLimit, Math.min(bottomLimit, totaly));
            
                instance.pan({ x: totalx, y: totaly })
                pannedX = ev.deltaX
                pannedY = ev.deltaY
            }


            // Handle pan
            hammer.on('panstart panmove', function (ev) {
                // On pan start reset panned variables
                if (ev.type === 'panstart') {
                   startPan(ev);
                } else {
                    pan(ev);
                }
            })

            hammer.on('panend', function() {
               (node as HTMLElement).dispatchEvent(new CustomEvent('panend',{}));
            })

            // Handle pinch
            hammer.on('pinchstart pinchmove', function (ev) {
                // On pinch start remember initial zoom
                if (ev.type === 'pinchstart') {
                    startPan(ev);
                    initialScale = instance.getZoom()
                    pinchCenter = { x: ev.center.x, y: ev.center.y }
                    instance.zoomAtPoint(initialScale * ev.scale, pinchCenter)
                }

                instance.zoomAtPoint(initialScale * ev.scale, pinchCenter)
                pan(ev);
            })
    
            // Prevent moving the page on some devices when panning over SVG
            options.svgElement.addEventListener('touchmove', function (e) { e.preventDefault(); });
        },

        destroy: function () {
            hammer.destroy()
        }
    }

    // Expose to window namespace for testing purposes
    var panZoom = svgPanZoom(node, {
        zoomEnabled: true,
        dblClickZoomEnabled: false,
        mouseWheelZoomEnabled: true,
        zoomScaleSensitivity: 0.3,
        fit: true,
        center: true,
        customEventsHandler: eventsHandler,
    });

    return { 
        destroy() {
            panZoom.destroy();
        }
    }
}